// The Comic Machine - Layer UI

var LayerController = (function() {

  // Handles UI and DOM manipulation
  var UI = {

    // Placeholder for DOM element references
    elements: {},

    // Initialize the UI and DOM manager
    initialize: function(container) {

      var container = document.querySelector(".layers") || document;

      // Set base container
      UI.elements.container = container;

      UI.elements.layers = {
        list: container.querySelector(".layer-list"),
        add: document.querySelector(".layer-add"),
        edit: document.querySelector(".layer-edit"),
      };

      UI.elements.breadcrumbs = {
        wrapper: document.getElementById("breadcrumb-wrapper"),
        home: document.getElementById("breadcrumb-home"),
        layer: document.getElementById("breadcrumb-layer"),
        text: document.getElementById("breadcrumb-text"),
      };

      // Bind handlers to events
      UI.bindEvents();

      // Update the UI
      UI.updateDOM();

    },

    // Bind handlers to events
    bindEvents: function() {

      var dialog = document.querySelector(".dialog");
      var layerCollection = document.querySelector(".layer-collection");

      // Update the UI on page change
      Events.global.on("tcm.page.selected", UI.updateDOM);
      Events.global.on("tcm.layer.update", UI.updateDOM);
      Events.global.on("tcm.comic.reset", UI.updateDOM);

      // Update the breadcrumbs on layer change
      Events.global.on("tcm.layer.update", UI.updateBreadcrumbs);
      Events.global.on("tcm.layer.text", UI.updateBreadcrumbs);

      // Handle on click of the breadcrumb buttons
      attachHandler(UI.elements.breadcrumbs.home, function(event) {
        if (TextController.active) {
          Events.global.emit("tcm.layer.text.close");
        }
        Page.selectLayer(0);
      });
      attachHandler(UI.elements.breadcrumbs.layer, function(event) {
        if (TextController.active) {
          Events.global.emit("tcm.layer.text.close");
        } else {
          Page.selectLayer(0);
        }
      });
      attachHandler(UI.elements.breadcrumbs.text, function(event) {
        Events.global.emit("tcm.layer.text.close");
      });

      // Handle on click of edit layer
      attachHandler(UI.elements.layers.edit, function(event, i) {
        Page.editLayer();
      });

      // Handle on click of edit layer
      var layerCollection = document.querySelector(".layer-collection");
      attachHandler(layerCollection.querySelector(".close"), function(event, i) {
        layerCollection.setAttribute("data-active", "false");
      });

      // Handle file upload from form
      var fileInput = attachHandler("#input", UI.uploadFile, "change");

      // Handle file upload event to dispatch mouse event
      Events.global.on("tcm.layer.upload", function(event) {
        var clickEvent = new MouseEvent("click", {
          "view": window,
          "bubbles": true,
          "cancelable": false
        });
        fileInput.dispatchEvent(clickEvent);
      });

      // Handle file upload buton
      attachHandler(".button-upload", function(event) {
        Events.global.emit("tcm.layer.upload");
      });

    },

    // Update the UI and DOM elements with the current data
    updateDOM: function() {

      var list = UI.elements.layers.list;

      // Return if the list element does not exist
      if (!list || !Comic.current) {
        return;
      }

      var items = document.createDocumentFragment();
      var page = Comic.currentPage();
      var layers = page.pageLayers.slice();
      var selected = page.layerIndex;

      // Loop over comic pages to add to UI
      for (var i = layers.length; i > 0; i--) {
        var index = i - 1;
        var item = new LayerListItem({
          layer: layers[index],
          selected: selected,
          index: index
        });
        items.appendChild(item.template);
      }

      // Append the list items to the list element
      list.innerHTML = "";
      list.appendChild(items);

    },

    // Handles updated the breadcrumbs
    updateBreadcrumbs: function(isEditingText) {

      var index = Page.currentLayerIndex();
      var layer = Page.currentLayer();
      var name = layer && layer.name ? layer.name : "Layer " + index;
      var showText = false;
      var showLayer = false;

      if (isEditingText) {
        showText = true;
        showLayer = true;
      }

      if (index > 0) {
        showLayer = true;
        UI.elements.breadcrumbs.layer.innerHTML = name;
      }

      // Setting "active" shows the item, where "selected" adds the close button
      UI.elements.breadcrumbs.layer.classList.toggle("active", showLayer);
      UI.elements.breadcrumbs.layer.classList.toggle("selected", showLayer && !showText);

      UI.elements.breadcrumbs.text.classList.toggle("active", showText);
      UI.elements.breadcrumbs.text.classList.toggle("selected", showText);

      UI.elements.breadcrumbs.home.classList.toggle("selected", !showLayer);

    },

    // Handles uploading the file to the server and creating the asset instance
    uploadFile: function(event) {

      var file = event.target.files[0];
      var index = Comic.currentPage().layerIndex;

      document.querySelector(".loading").setAttribute("data-active", "true");

      Canvas.readFile(file, function(src, name) {

        var page = Comic.currentPage();
        var layer = null;
        if (index === 0) {
          layer = page.addLayer();
        } else {
          layer = page.addLayer(null, index + 1);
        }

        Asset.loadImage(src, function(image) {

          if (!image || !layer) return console.log(src, image);

          var options = {
            name: name,
            image: image,
            file: file
          };

          // Create the asset
          var asset = new Asset(options, function(asset) {
            // Set the returned asset
            layer.asset = asset;
            // Set image content
            layer.content = image;
            // Set the layer name
            layer.name = name;
            // Set the layer type
            layer.type = Layer.Types.IMAGE;
            // Set layer/canvas size
            layer.setSize(image.width, image.height);
            // Set proportion lock
            layer.proportionLock = true;
            // Draw the image on the canvas
            layer.canvas.drawImage(image);
            // Generate the thumbnail
            layer.updateThumbnail();
            // Update UI
            Events.global.emit("tcm.layer.update");
            // Render the updated page
            // Comic.renderPage();
          });

        });

      });

      // Remove the current image
      event.target.value = "";

    },

  };

  // Wait for the comic to initialize before initializing the UI manager
  Events.global.on("tcm.initialized", UI.initialize);

  // Public / exposed object
  return UI;

})();
